import { HugeiconsIcon } from "@hugeicons/react";
import { ChevronLeft, ChevronRight } from "@hugeicons/core-free-icons";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import {
  WEEKDAY_LABELS,
  buildMiniCalendarDays,
  formatMonthYear,
} from "./utils";

interface AppointmentsMiniCalendarProps {
  currentDate: Date;
  onSelectDate: (date: Date) => void;
  onMonthChange: (date: Date) => void;
}

export const AppointmentsMiniCalendar = ({
  currentDate,
  onSelectDate,
  onMonthChange,
}: AppointmentsMiniCalendarProps) => {
  const days = buildMiniCalendarDays(currentDate);
  const today = new Date().toDateString();

  return (
    <div className="rounded-xl border border-border bg-muted/30 p-3">
      <div className="mb-3 flex items-center justify-between gap-2">
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-lg"
          onClick={() => {
            const nextDate = new Date(currentDate);
            nextDate.setMonth(nextDate.getMonth() - 1);
            onMonthChange(nextDate);
          }}
          aria-label="Previous month"
        >
          <HugeiconsIcon icon={ChevronLeft} size={16} />
        </Button>
        <h3 className="z-body-md text-foreground">
          {formatMonthYear(currentDate)}
        </h3>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-8 w-8 rounded-lg"
          onClick={() => {
            const nextDate = new Date(currentDate);
            nextDate.setMonth(nextDate.getMonth() + 1);
            onMonthChange(nextDate);
          }}
          aria-label="Next month"
        >
          <HugeiconsIcon icon={ChevronRight} size={16} />
        </Button>
      </div>

      <div className="grid grid-cols-7 gap-1">
        {WEEKDAY_LABELS.map((label) => (
          <div
            key={label}
            className="flex h-8 items-center justify-center text-center z-caption text-muted-foreground"
          >
            {label}
          </div>
        ))}

        {days.map((day) =>
          day.date ? (
            <button
              key={day.key}
              type="button"
              onClick={() => onSelectDate(day.date as Date)}
              className={cn(
                "flex h-8 items-center justify-center rounded-lg z-caption z-numeric transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
                day.date.toDateString() === currentDate.toDateString() &&
                  "bg-primary text-primary-foreground hover:bg-primary/90",
                day.date.toDateString() !== currentDate.toDateString() &&
                  day.date.toDateString() === today &&
                  "bg-accent text-accent-foreground",
                day.date.toDateString() !== currentDate.toDateString() &&
                  day.date.toDateString() !== today &&
                  "text-foreground hover:bg-accent hover:text-accent-foreground"
              )}
            >
              {day.label}
            </button>
          ) : (
            <div key={day.key} className="h-8" />
          )
        )}
      </div>
    </div>
  );
};
